import React from 'react';
import { X } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

// Modal mejorado con animaciones y diseño moderno
export const Modal = ({ isOpen, onClose, title, children, size = 'md', showClose = true }) => {
  const { isDark } = useTheme();

  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl'
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn"
      onClick={onClose}
    >
      <div 
        className={`${sizeClasses[size]} w-full rounded-2xl shadow-2xl transform transition-all ${
          isDark ? 'bg-gray-800 border border-gray-700' : 'bg-white'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        {(title || showClose) && (
          <div className={`flex items-center justify-between p-6 border-b ${
            isDark ? 'border-gray-700' : 'border-gray-200'
          }`}>
            {title && (
              <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                {title}
              </h2>
            )}
            {showClose && (
              <button
                onClick={onClose}
                className={`p-2 rounded-lg transition-colors ${
                  isDark 
                    ? 'hover:bg-gray-700 text-gray-400 hover:text-white' 
                    : 'hover:bg-gray-100 text-gray-500 hover:text-gray-700'
                }`}
              >
                <X className="w-6 h-6" />
              </button>
            )}
          </div>
        )}

        {/* Content */}
        <div className="p-6 max-h-[70vh] overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

// Alert mejorado con íconos y colores
export const Alert = ({ type = 'info', title, message, onClose }) => {
  const { isDark } = useTheme();

  const styles = {
    success: {
      icon: '✅',
      light: 'bg-green-50 border-green-200 text-green-800',
      dark: 'bg-green-900/30 border-green-700 text-green-300'
    },
    error: {
      icon: '❌',
      light: 'bg-red-50 border-red-200 text-red-800',
      dark: 'bg-red-900/30 border-red-700 text-red-300'
    },
    warning: {
      icon: '⚠️',
      light: 'bg-yellow-50 border-yellow-200 text-yellow-800',
      dark: 'bg-yellow-900/30 border-yellow-700 text-yellow-300'
    },
    info: {
      icon: 'ℹ️',
      light: 'bg-blue-50 border-blue-200 text-blue-800',
      dark: 'bg-blue-900/30 border-blue-700 text-blue-300'
    }
  };

  const style = styles[type];

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn">
      <div 
        className={`max-w-md w-full rounded-2xl shadow-2xl p-8 border-2 ${
          isDark ? style.dark : style.light
        }`}
      >
        <div className="text-center">
          <div className="text-6xl mb-4">{style.icon}</div>
          {title && (
            <h3 className="text-2xl font-bold mb-3">{title}</h3>
          )}
          {message && (
            <p className="text-lg mb-6 leading-relaxed whitespace-pre-line">{message}</p>
          )}
          <button
            onClick={onClose}
            className={`px-8 py-3 rounded-lg font-bold transition-colors w-full ${
              type === 'success' ? 'bg-green-600 hover:bg-green-700 text-white' :
              type === 'error' ? 'bg-red-600 hover:bg-red-700 text-white' :
              type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700 text-white' :
              'bg-blue-600 hover:bg-blue-700 text-white'
            }`}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default { Modal, Alert };
